import { cx, styled } from "simplydo/react/styled";

import type { SegmentGroupProps } from "./Segment.types";

const StyledSegmentGroup = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  border-radius: 0.28571429rem;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  border: 1px solid rgba(34, 36, 38, 0.15);
  overflow: hidden;

  &.is-horizontal {
    flex-direction: row;
  }

  > * {
    margin: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    border: none !important;
    border-top: 1px solid rgba(34, 36, 38, 0.15) !important;
  }

  > *:first-child {
    border-top: none !important;
  }
`;

const SegmentGroupComponent = (props: SegmentGroupProps) => {
  const { children, className, style, horizontal } = props;
  return (
    <StyledSegmentGroup
      className={cx(horizontal && "is-horizontal", className)}
      style={style}
    >
      {children}
    </StyledSegmentGroup>
  );
};

export const SegmentGroup = styled(SegmentGroupComponent)``;
